var classes = {"arrow":"arrow__6ULaW","prefers-reduce-motion":"prefers-reduce-motion__e0pCc"};

export { classes as default };
//# sourceMappingURL=base-tooltip.module.scss.js.map
